module.exports = __webpack_public_path__ + "img/37.378f79b9.svg";